import styled from "@emotion/styled";
import { media } from "../../components/Window/themes";
const ChannelList = {
    Wrapper: styled.div `
    display: grid;
    grid-column: 1/-1;
    background-color: ${({ theme }) => theme.color.background};
    height: 100%;
    row-gap: 0;
    column-gap: 1rem;
    min-height: 100%;
    position: relative;
    grid-template-columns: clamp(300px, 400px, 400px) 1fr;
    ${media.medium} {
      grid-template-columns: minmax(0, 1fr);
    }
  `,
    ListWrapper: styled.div `
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-width: 100%;
    ${media.medium} {
      display: ${(props) => (props.isCollapsable ? "none" : "flex")};
    }
  `,
    OuterListWrapper: styled.div `
    height: 100%;
    overflow: hidden;
  `,
    List: styled.ul `
    padding: 0;
    list-style-type: none;
    margin: 0px;
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.color.backgroundAside};
    overflow-y: auto;
    height: 100%;
  `,
    Padder: styled.div `
    min-height: 20px;
    background-color: ${({ theme }) => theme.color.backgroundAside};
  `,
    PannelWrapper: styled.div `
    min-height: 0;
    display: flex;
    flex-direction: column;
    min-width: 0;
    ${media.medium} {
      display: ${(props) => (props.isCollapsable ? "block" : "none")};
    }
  `,
    UserList: styled.ul `
    padding: 0;
    list-style-type: none;
    background-color: ${({ theme }) => theme.color.backgroundAside};
    display: none;
  `,
    ChannelListHeader: styled.div `
    font-weight: bold;
    color: ${({ theme }) => theme.color.headerTextColor};
    padding: 0.4rem;
    border-bottom: 0.1rem solid rgba(6, 6, 7, 0.08);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
  `,
    ChannelsListWrapper: styled.div `
    width: 100%;
  `,
    AsideWrapper: styled.div `
    display: flex;
  `,
    DirectMessageWrapper: styled.div `
    background-color: ${({ theme }) => theme.color.backgroundAside};
    padding: 1rem 2rem 0rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  `,
    DirectMessageTitle: styled.div `
    font-size: 13px;
    line-height: 16px;
    height: 16px;
    color: ${({ theme }) => theme.color.textMuted};
    margin-bottom: 10px;
  `,
    DirectMessageButton: styled.button `
    border: none;
    background: none;
    cursor: pointer;
  `,
    ChannelSearchContainer: styled.div `
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.4rem;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    background-color: ${({ theme }) => theme.color.backgroundBrand};
    ${media.medium} {
      padding: 0 1rem 0;
    }
  `,
    ChannelSearchInputWrapper: styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    border-radius: 8px;
    border: 1px solid transparent;
  `,
    ChannelSearchInputIcon: styled.div `
    width: 19rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    justify-content: start;
    margin-left: 1em;
  `,
    ChannelSearchInputText: styled.input `
    background: none;
    border: none;
    font-size: 16px;
    outline: none;
    color: white;
    width: 100%;
    ::placeholder {
      color: ${({ theme }) => theme.color.background};
      overflow: visible;
    }
    ${media.medium} {
      font-size: 0.8rem;
    }
  `,
    ShowUsersButton: styled.button `
    border: none;
    background: none;
    cursor: pointer;
  `,
    MessageInfoWrapper: styled.div `
    display: flex;
    justify-content: center;
  `,
    MessageInfo: styled.p `
    color: ${({ theme }) => theme.color.text};
    place-self: center;
    box-shadow: 0px 4px 12px -2px ${({ theme }) => theme.color.backgroundBrand};
    margin: 25px;
    padding: 25px;
    border-top-right-radius: 25px;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    font-style: italic;
  `,
    SettingsIconDiv: styled.div `
    position: absolute;
    right: 1em;
    top: 0.95em;
    z-index: 1;
    cursor: pointer;
    ${media.medium} {
      display: ${(props) => (props.isCollapsable ? "block" : "none")};
      top: 0.8em;
      right: 0.3em;
    }
  `,
    LeftArrowIconDiv: styled.div `
    display: none;
    ${media.medium} {
      position: absolute;
      left: 1em;
      top: 0.8em;
      z-index: 1;
      cursor: pointer;
      display: block;
    }
  `,
    LeftArrowIcon: styled.span `
    ${media.medium} {
      display: ${(props) => (props.isCollapsable ? "block" : "none")};
    }
  `,
    RightArrowIconDiv: styled.div `
    display: none;
    ${media.medium} {
      position: absolute;
      right: 3em;
      top: 1em;
      z-index: 1;
      cursor: pointer;
      display: block;
    }
  `,
    RightArrowIcon: styled.span `
    ${media.medium} {
      display: ${(props) => (props.isCollapsable ? "none" : "block")};
    }
  `,
    HeaderButton: styled.button `
    display: flex;
    gap: 6px;
    align-items: center;
    border-radius: 8px;
    font-size: 1rem;
    line-height: 1.5;
    border: 1px solid;
    border-color: ${({ theme }) => theme.color.backgroundBrand};
    color: ${({ theme }) => theme.color.backgroundBrand};
    background-color: transparent;
    padding: 0.375rem 0.75rem;
    white-space: nowrap;
    &:hover {
      color: ${(props) => props.disabled
        ? ({ theme }) => theme.color.backgroundBrand
        : ({ theme }) => theme.color.background};
      background-color: ${(props) => props.disabled
        ? "transparent"
        : ({ theme }) => theme.color.backgroundBrand};
      border-color: ${({ theme }) => theme.color.backgroundBrand};
    }
    &:disabled {
      opacity: 0.5;
    }
    ${media.medium} {
      font-weight: 200 !important;
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
      margin-right: 5rem;
    }
  `,
};
export default ChannelList;
//# sourceMappingURL=ChannelList.styled.js.map